import magnificPopup from 'magnific-popup/dist/jquery.magnific-popup.min.js';
jQuery(function () {
  if (jQuery('.gallery').length) {
    jQuery('.gallery').each(function () {
      var holder = jQuery(this);
      var lighboxOpener = holder.find('a');
      lighboxOpener.magnificPopup({
        type: 'image',
        closeOnContentClick: false,
        closeBtnInside: false,
        mainClass: 'mfp-with-zoom',
        gallery: {
          enabled: true
        },
        zoom: {
          enabled: true,
          duration: 300,
          opener: function opener(element) {
            return element.find('img');
          }
        }
      });
    });
  }
});